import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const IdXboxWelcomePartnerPage = loadable(() =>
  withDefaultLoaderModifiers(import("./IdXboxWelcomePartnerPage"))
);

export const IdXboxWelcomePartnerFormPreview = loadable(() =>
  withDefaultLoaderModifiers(import("../FormPreview/IdXboxWelcomePartnerFormPreview"))
);
